"use client";

import { ComponentPropsWithRef, FC, SubmitEvent } from "react";
import { useBuilderFormsContext } from "@/hooks";

export type FormProps = Omit<ComponentPropsWithRef<"form">, "onSubmit"> & {
  onSubmit?: (
    event: SubmitEvent<HTMLFormElement>,
    correlationId: string,
  ) => void;
};
export const Form: FC<FormProps> = (props) => {
  const { correlationId } = useBuilderFormsContext();

  return (
    <form {...props} onSubmit={(e) => props.onSubmit?.(e, correlationId)} />
  );
};
